/* eslint-disable */
export const ls = {
  set(variable, value, ttl_ms) {
    const data = {
      value: value,
      expires_at: new Date().getTime() + ttl_ms / 1,
    };
    localStorage.setItem(variable.toString(), JSON.stringify(data));
  },
  get(variable) {
    const data = JSON.parse(localStorage.getItem(variable.toString()));
    if (data !== null) {
      if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
        localStorage.removeItem(variable.toString());
      } else {
        return data.value;
      }
    }
    return null;
  },
};

export default {
  ls,
};
